export const OpenFile = {
  "Modal": {
    "Title": "Open File",
    "TitleForAiPlugin": "Select File",
    "AllFiles": "All Files",
    "Excel": "MS Excel",
    "Word": "MS Word",
    "PPT": "MS PowerPoint",
    "Visio": "MS Visio",
    "TXT": "TXT",
    "ImageFiles": "Image",
    "Html": "HTML",
    "PDF": "PDF",
    "WPS": "WPS",
    "HanWord": "HanWord",
    "ChooseFileForCanvas": "Choose File",
    "ReloadPage":"Failed to get the setting, please try to reload this page.",
  },
  "UploadSuccess": "upload success",
  "UploadFailed": "upload failed"
}